export const COLORS = {
  green: '#98C11E',
  blue: '#1C4677',
  lightGray: '#eeeeee',
  darkGray: '#cccccc',
  altBlue: '#3f56a4',
  altSalmon: '#dc8385',
  altGreen: '#c2d845',
};
